<template>
  <div>
    <form @submit.prevent="submit">
      <div class="form-group">
        <p class="text-cpf text-color-3">
          Olá,
          <span>{{ name }}</span>!
        </p>
        <p class="text-color-3">
          Por favor, insira seu
          <span v-if="isForeign">RNE</span>
          <span v-if="!isForeign">CPF</span>.
        </p>
      </div>
      <div class="form-group">
        <FloatingLabel
          v-if="!isForeign"
          type="tel"
          input-class="form-control form-control-xl border-color-3"
          label="CPF"
          v-model="document"
          v-mask="'###.###.###-##'"
          v-on:blur="checkDocument"
        />
        <FloatingLabel
          v-if="isForeign"
          type="tel"
          input-class="form-control form-control-xl border-color-3"
          label="RNE"
          v-model="document"
          v-mask="'XXXXXXXXXXXXXXXXXXXXXXXXXXXX'"
          v-on:blur="checkDocument"
        />
        <small class="form-text text-danger" v-if="documentMessage">{{ documentMessage }}</small>
      </div>

      <!-- <div
        class="custom-control custom-checkbox custom-checkbox-lg custom-checkbox-background mb-5"
      >
        <input type="checkbox" class="custom-control-input" id="foreign" v-model="isForeign" />
        <label class="custom-control-label text-color-3" for="foreign">Sou estrangeiro</label>
      </div> -->
      <div class="d-flex align-items-center justify-content-center text-center">
        <button type="submit" class="btn btn-color-1 text-white px-4 btn-block" :disabled="!canSubmit">Enviar</button>
      </div>
    </form>
  </div>
</template>

<script>
import FloatingLabel from "@/components/FloatingLabel";

export default {
  name: "InsertCpf",

  data() {
    return {
      isForeign: false,
      name: "",
      document: "",
      documentMessage: null
    };
  },

  mounted() {
    let fixCapitalsText = this.$route.query.name;
    this.name = fixCapitalsText
      .toLowerCase()
      .replace(/(?:^|\s)\S/g, function(a) {
        return a.toUpperCase();
      });
  },

  computed: {
    canSubmit() {
      return (
        (this.isForeign && this.document.length > 5) ||
        (!this.isForeign && this.$helpers.isCPF(this.document))
      );
    }
  },

  methods: {
    checkDocument() {
      if (!this.isForeign) {
        this.documentMessage = this.$helpers.isCPF(this.document)
          ? null
          : "CPF inválido";
      } else {
        this.documentMessage = this.document.length > 5 ? null : "RNE inválido";
      }
    },

    submit() {
      this.$store
        .dispatch("user/updateHunting", {
          token: this.$route.query.code,
          document: this.document,
          foreigner: this.isForeign
        })
        .then(user => {
          let user_id = user.data.updateHunting.id;
          let check_id = this.$store.state.user.profile.id;

          if (user_id == check_id) {
            // this.$router.push(`/meu-perfil`);
            this.$router.push(`/`);
          } else {
            this.$store.dispatch("user/signOut");

            this.$store.dispatch("user/auth", {
              user: {
                id: user_id,
                name: name
              },
              keepLogged: true
            });
            setTimeout(() => {
              this.$store
                .dispatch(
                  "graphql_queries/query",
                  `
                      user( id: "${user_id}" ){
                        profile{
                          cpf,
                        }
                      },
                    `
                )
                .then(results => {
                  // this.$router.push(`/meu-perfil`);
                  this.$router.push(`/`);
                });
            }, 500);
          }
        });
    }
  },

  components: {
    FloatingLabel
  }
};
</script>

<style lang="scss" scoped>
</style>